import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { commonHttpClient } from './http-clients/common-http-client'

export interface UserData {
  id: string
  firstName: string
  lastName: string
  dashboardLocale: PageLocaleEnum
  timezone: string
  userPlanId: number
  roles: string[]
  country: string
  impersonator?: {
    id: string
    email: string
    roles: string[]
  }
}

export const fetchUserData = async (): Promise<UserData> => {
  const response = await commonHttpClient.get('/api/dashboard/user/user-data')
  return response.data
}
